import React from 'react';
import { cn } from 'src/domains/common/components/utils';

interface PropsType {
    checked: boolean;
    onChange: (checked: boolean) => void;
    className?: string;
    disabled?: boolean;
    indeterminate?: boolean;
}

export const Checkbox = ({
    checked,
    onChange,
    className = '',
    disabled = false,
    indeterminate = false,
}: PropsType): JSX.Element => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (!disabled) {
            onChange(e.target.checked);
        }
    };

    return (
        <div className='relative inline-flex items-center'>
            <input
                type='checkbox'
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                ref={(el) => {
                    if (el !== null) el.indeterminate = indeterminate;
                }}
                className={cn(
                    'h-4 w-4 appearance-none rounded border border-solid border-blue-500 shadow-sm',
                    {
                        'bg-blue-500': indeterminate || checked,
                        'bg-white': !indeterminate && !checked,
                        'opacity-50 cursor-not-allowed': disabled,
                        'cursor-pointer': !disabled,
                    },
                    className
                )}
            />
            {checked && !indeterminate && (
                <div className='absolute inset-0 flex items-center justify-center pointer-events-none'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='14'
                        height='14'
                        viewBox='0 0 14 14'
                        fill='none'
                        className='text-white'
                    >
                        <path
                            d='M10.4287 3.8969C10.4577 3.91589 10.4708 3.94979 10.4648 3.98186L10.4531 4.01213L6.48628 10.0785C6.47964 10.0887 6.47099 10.1076 6.46089 10.1039L6.42671 10.1156C6.41476 10.1171 6.40282 10.1163 6.39155 10.1127L6.3603 10.0951L3.7939 7.76115C3.76849 7.73792 3.76066 7.70287 3.77143 7.67229L3.78804 7.64397C3.81135 7.61832 3.84716 7.61056 3.87788 7.62151L3.9062 7.63811L5.96675 9.51115L6.40034 9.90569L6.72163 9.41545L10.3134 3.92131C10.3324 3.89235 10.3664 3.87832 10.3984 3.8842L10.4287 3.8969Z'
                            fill='#0F172A'
                            stroke='#FAFAFA'
                        />
                    </svg>
                </div>
            )}
            {indeterminate && (
                <div className='absolute inset-0 flex items-center justify-center pointer-events-none'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='14'
                        height='14'
                        viewBox='0 0 14 14'
                        fill='none'
                    >
                        <path
                            d='M2.91667 7H11.0833'
                            stroke='#FAFAFA'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                </div>
            )}
        </div>
    );
};
